import {
  confirmRefundOffer,
  deleteRefundOffer,
  getManageFlowBookingById,
  getManageFlowBookingByNumberAndEmail,
  getManageFlowTravelAccountsMap,
  initiateLegsRefund,
  initiateNonTripOffersRefund,
  sendTicketsToEmail,
} from '@/features/manage/manageActions';
import {
  deleteProfile,
  getProfileActiveTickets,
  getProfileActiveTravelPasses,
  getProfileActiveVouchers,
  getProfileHistoryTickets,
  getProfileHistoryTravelPasses,
  getProfileHistoryVouchers,
  updateProfile,
} from '@/features/profile/profileActions';
import {
  addPurchaseFlowBookingAncillaries,
  createPurchaseFlowNonTripOfferBooking,
  createPurchaseFlowTripOfferBooking,
  deletePurchaseFlowBooking,
  getInboundExchangeOffers,
  getInboundJourneys,
  getNonTripOffers,
  getOutboundExchangeOffers,
  getOutboundJourneys,
  getPurchaseFlowBookingAdditionalOffersSearch,
  getPurchaseFlowBookingById,
  getPurchaseFlowTravelAccountsMap,
  initiateAdyenPayment,
  initiateExternalPayment,
  initiateZeroPayment,
  startExchange,
  updateBookingPassengers,
  updatePurchaseFlowBookingPurchaser,
} from '@/features/purchase/purchaseActions';
import {
  changePassword,
  resetPassword,
  sendPasswordResetLink,
} from '@/features/reset-password/resetPasswordActions';
import { createLoadingSelector } from '@/store/utils';

export const purchaseFlowBookingFetchingLoadingSelector = createLoadingSelector(
  getPurchaseFlowBookingById
);

export const outboundOrInboundJourneysLoadingSelector = createLoadingSelector(
  getOutboundJourneys,
  getInboundJourneys,
  getOutboundExchangeOffers,
  getInboundExchangeOffers
);

export const nonTripOffersLoadingSelector =
  createLoadingSelector(getNonTripOffers);

export const purchaseFlowBookingCreationLoadingSelector = createLoadingSelector(
  createPurchaseFlowTripOfferBooking,
  createPurchaseFlowNonTripOfferBooking,
  getPurchaseFlowBookingById,
  // Change-booking commit: keep the offer-list "Continue" button pending
  // through `startExchange` + the manage-booking refetch so a double-click
  // can't create two PREBOOKED exchange operations.
  startExchange,
  getManageFlowBookingById
);

export const addAncillaryLoadingSelector = createLoadingSelector(
  addPurchaseFlowBookingAncillaries
);

export const checkoutLoadingSelector = createLoadingSelector(
  getPurchaseFlowBookingById,
  getPurchaseFlowBookingAdditionalOffersSearch,
  getPurchaseFlowTravelAccountsMap
);

export const manageBookingSearchLoadingSelector = createLoadingSelector(
  getManageFlowBookingByNumberAndEmail,
  getManageFlowTravelAccountsMap
);

export const manageBookingRefundLoadingSelector = createLoadingSelector(
  initiateLegsRefund,
  initiateNonTripOffersRefund,
  deleteRefundOffer,
  confirmRefundOffer,
  getManageFlowBookingById
);

export const sendTicketsToEmailLoadingSelector =
  createLoadingSelector(sendTicketsToEmail);

export const sendPasswordResetLinkLoadingSelector = createLoadingSelector(
  sendPasswordResetLink
);

export const resetPasswordLoadingSelector =
  createLoadingSelector(resetPassword);

export const changePasswordLoadingSelector =
  createLoadingSelector(changePassword);

export const initiatePaymentLoadingSelector = createLoadingSelector(
  updateBookingPassengers,
  updatePurchaseFlowBookingPurchaser,
  initiateAdyenPayment,
  initiateExternalPayment,
  initiateZeroPayment
);

export const profileBookingSearchLoadingSelector = createLoadingSelector(
  getManageFlowBookingByNumberAndEmail,
  getManageFlowTravelAccountsMap,
  getProfileActiveTickets,
  getProfileHistoryTickets,
  getProfileActiveTravelPasses,
  getProfileHistoryTravelPasses,
  getProfileActiveVouchers,
  getProfileHistoryVouchers
);

export const updateProfileLoadingSelector =
  createLoadingSelector(updateProfile);

export const deleteProfileLoadingSelector =
  createLoadingSelector(deleteProfile);

export const updatePassengersLoadingSelector = createLoadingSelector(
  updateBookingPassengers
);

export const cancelBookingLoadingSelector = createLoadingSelector(
  deletePurchaseFlowBooking
);
